import PropTypes from 'prop-types';
import React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { INBOX_OTHERS_TOOLTIP } from '../../../../../constants/texts';
import ConversationParticipant from './ConversationParticipant.container';
import { Container } from './ConversationModalParticipants.styled';
import ConversationModalParticipantsLoader from './ConversationModalParticipantsLoader';
import StyledTooltip from '../common/StyledTooltip';
import { analyticsTrackEvent } from '@core/utils/analytics';
import { MESSAGE_PARTICIPANTS_VIEWED } from '@core/constants/analytics';

const PARTICIPANTS_THRESHOLD = 3;
const TO_DISPLAY = 2;

const partitionParticipants = (threshold, displayCount) => (participants) => {
  if (participants.length > threshold) {
    return [
      participants.slice(0, displayCount),
      participants.slice(displayCount),
    ];
  }

  return [participants, []];
};

class ConversationModalParticipants extends React.PureComponent {
  componentDidMount() {
    this.props.fetchUsers();
  }

  componentDidUpdate() {
    this.props.fetchUsers();
  }

  handleOpenViewParticipants = () => {
    analyticsTrackEvent(MESSAGE_PARTICIPANTS_VIEWED);
    this.props.openViewParticipants();
  };

  render() {
    const { isDarkMode } = this.props;

    if (this.props.isFetchingUsers) {
      return (
        <Container>
          <ConversationModalParticipantsLoader
            isGroupConversation={this.props.isGroupConversation}
          />
        </Container>
      );
    }

    // For individual conversations, show single avatar
    if (!this.props.isGroupConversation) {
      const participantId = this.props.otherParticipantsIds[0];
      if (!participantId) return null;

      return (
        <Container data-testid="conversation-participants-individual">
          <ConversationParticipant participantId={participantId} />
        </Container>
      );
    }

    // For group conversations, show stacked avatars
    const partition = partitionParticipants(PARTICIPANTS_THRESHOLD, TO_DISPLAY);
    const [othersToDisplay, othersToHide] = partition(
      this.props.otherParticipantsIds
    );
    const moreCount = othersToHide.length;

    return (
      <Container data-testid="conversation-participants">
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          {othersToDisplay.map((participant, index) => (
            <div
              key={participant}
              style={{
                marginLeft: index > 0 ? '-6px' : '0',
                zIndex: othersToDisplay.length - index,
              }}
            >
              <ConversationParticipant participantId={participant} />
            </div>
          ))}
          {moreCount > 0 && (
            <div
              style={{
                marginLeft: '-6px',
                zIndex: 0,
              }}
            >
              <StyledTooltip
                title={INBOX_OTHERS_TOOLTIP}
                position="bottom"
                arrow
              >
                <Avatar
                  onClick={this.handleOpenViewParticipants}
                  sx={{
                    cursor: 'pointer',
                    width: 40,
                    height: 40,
                    fontSize: moreCount >= 10 ? '1rem' : '1.25rem',
                    backgroundColor: isDarkMode ? '#D7D2DF' : '#5D536C',
                    color: isDarkMode ? '#000' : '#fff',
                  }}
                >
                  +{moreCount}
                </Avatar>
              </StyledTooltip>
            </div>
          )}
        </Stack>
      </Container>
    );
  }
}

ConversationModalParticipants.propTypes = {
  fetchUsers: PropTypes.func.isRequired,
  isFetchingUsers: PropTypes.bool.isRequired,
  isGroupConversation: PropTypes.bool.isRequired,
  openViewParticipants: PropTypes.func.isRequired,
  otherParticipantsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isDarkMode: PropTypes.bool,
};

ConversationModalParticipants.defaultProps = {
  isDarkMode: false,
};

export default ConversationModalParticipants;
